import {
  CLEAR_FAULT_ERROR,
  CLEAR_FAULT_HISTORY,
  ERROR_FAULT,
  ERROR_FAULT_HISTORY,
  LOADING_FAULT,
  LOADING_FAULT_HISTORY,
  SUCCESS_FAULT_HISTORY,
  SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES,
  SUCCESS_GET_FAULT_HISTORY_BY_DATE,
  SUCCESS_GET_FAULT_NATURE_OF_BILL,
  SUCCESS_GET_FAULT_NATURE_OF_SERVICE,
} from '../../const/actionTypes';
import { IServiceFaultListItem } from '../../interfaces/fault';

interface IInitialState {
  loading: boolean;
  error: string;
  dataFaultNatureServiceBundle: [];
  dataFaultNatureBillBundle: [];
  dataBundle: [];
  dataObject: {};
  dataTechnicalContactObject: {};
  faultHistory: IServiceFaultListItem[];
  loadingFaultHistory: boolean;
}

const initialState: IInitialState = {
  loading: false,
  error: '',
  dataFaultNatureServiceBundle: [],
  dataFaultNatureBillBundle: [],
  dataBundle: [],
  dataObject: {},
  dataTechnicalContactObject: {},
  faultHistory: [],
  loadingFaultHistory: false,
};

export type FaultState = Readonly<typeof initialState>;

const faultReducer = (state = initialState, action: any): FaultState => {
  switch (action.type) {
    case LOADING_FAULT: {
      return {
        ...state,
        loading: true,
      };
    }

    case SUCCESS_GET_FAULT_NATURE_OF_SERVICE: {
      return {
        ...state,
        loading: false,
        dataFaultNatureServiceBundle: action.payload,
      };
    }

    case SUCCESS_GET_FAULT_NATURE_OF_BILL: {
      return {
        ...state,
        loading: false,
        dataFaultNatureBillBundle: action.payload,
      };
    }

    case SUCCESS_GET_FAULT_HISTORY_BY_DATE: {
      return {
        ...state,
        loading: false,
        dataBundle: action.payload,
      };
    }

    case SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES: {
      return {
        ...state,
        loading: false,
        dataTechnicalContactObject: action.payload,
      };
    }

    case ERROR_FAULT: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CLEAR_FAULT_ERROR: {
      return {
        ...state,
        loading: false,
        error: '',
      };
    }

    case LOADING_FAULT_HISTORY: {
      return {
        ...state,
        loadingFaultHistory: true,
        faultHistory: [],
      };
    }

    case SUCCESS_FAULT_HISTORY: {
      return {
        ...state,
        loadingFaultHistory: false,
        faultHistory: action.payload,
      };
    }

    case ERROR_FAULT_HISTORY: {
      return {
        ...state,
        loadingFaultHistory: false,
      };
    }

    case CLEAR_FAULT_HISTORY: {
      return {
        ...state,
        faultHistory: [],
      };
    }

    default:
      return state;
  }
};

export default faultReducer;
